import React from "react"

import { Box, Typography } from "src/UILibrary"

export const AnswerItem = ({ answer }: { answer: string }) => {
  const replaceLink = (text: string) => {
    var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi
    return text.replace(urlRegex, function (url) {
      return '<a href="' + url + '">' + url + "</a>"
    })
  }

  return (
    <Box sx={{ mt: "0px", mx: "0px", p: "20px", bgcolor: "#FAFAFA" }}>
      <Typography.SubTitle
        className="notosans weight500"
        sx={{ mt: "0px", LineHeight: "24px" }}
        color="textPrimary"
        dangerouslySetInnerHTML={{ __html: replaceLink(answer) }}
      ></Typography.SubTitle>
    </Box>
  )
}
